<template>
    <div>
        <div class="text-center">
            <h1 class="mt-5">
                {{ $t('Page(NewProduct):Component(Text):wizard-label') }}
            </h1>
            <p class="mb-4 pb-75">
                {{ $t('Page(NewProduct):Component(Text):wizard-short-description') }}
            </p>
        </div>
        <b-row class="pricing-card text-center">
            <b-col
                sm="10"
                md="12"
                lg="10"
                class="mx-auto pl-4 pr-4"
            >
                <b-row class="justify-content-md-center">
                    <b-col>
                        <b-card-group deck>
                            <b-card align="center" v-if="isTypeAvailable(types.GROUP)">
                                <h3>{{ $t('Page(NewProduct):Component(Text):product-group-label') }}</h3>
                                <b-card-text class="mt-2">
                                    {{ $t('Page(NewProduct):Component(Text):product-group-description') }}
                                </b-card-text>

                                <!-- buttons -->
                                <b-button
                                    block
                                    class="mt-2"
                                    variant="primary"
                                    v-if="!isTypeSelected(types.GROUP)"
                                    @click="selectProductType(types.GROUP)"
                                >
                                    {{ $t('Page(NewProduct):Component(Button):product-group-select') }}
                                </b-button>
                                <b-button
                                    variant="outline-success"
                                    class="btn-icon rounded-circle"
                                    v-if="isTypeSelected(types.GROUP)"
                                >
                                    <feather-icon icon="CheckIcon" />
                                </b-button>
                            </b-card>
                            <b-card class="popular" align="center" v-if="isTypeAvailable(types.OWN)">

                                <h3>{{ $t('Page(NewProduct):Component(Text):own-product-label') }}</h3>
                                <b-card-text class="mt-2">
                                    {{ $t('Page(NewProduct):Component(Text):own-product-description') }}
                                </b-card-text>

                                <!-- buttons -->
                                <b-button
                                    block
                                    class="mt-2"
                                    variant="primary"
                                    v-if="!isTypeSelected(types.OWN)"
                                    @click="selectProductType(types.OWN)"
                                >
                                    {{ $t('Page(NewProduct):Component(Button):own-product-select') }}
                                </b-button>
                                <b-button
                                    variant="outline-success"
                                    class="btn-icon rounded-circle"
                                    v-if="isTypeSelected(types.OWN)"
                                >
                                    <feather-icon icon="CheckIcon" />
                                </b-button>
                            </b-card>
                            <b-card align="center" v-if="isTypeAvailable(types.PURCHASED)">
                                <h3>{{ $t('Page(NewProduct):Component(Text):purchased-product-label') }}</h3>
                                <b-card-text class="mt-2">
                                    {{ $t('Page(NewProduct):Component(Text):purchased-product-description') }}
                                </b-card-text>

                                <!-- buttons -->
                                <b-button
                                    block
                                    class="mt-2"
                                    variant="primary"
                                    v-if="!isTypeSelected(types.PURCHASED)"
                                    @click="selectProductType(types.PURCHASED)"
                                >
                                    {{ $t('Page(NewProduct):Component(Button):purchased-product-select') }}
                                </b-button>
                                <b-button
                                    variant="outline-success"
                                    class="btn-icon rounded-circle"
                                    v-if="isTypeSelected(types.PURCHASED)"
                                >
                                    <feather-icon icon="CheckIcon" />
                                </b-button>
                            </b-card>
                        </b-card-group>
                    </b-col>

                </b-row>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import { BCardText, BCard, BRow, BCol, BFormGroup, BButton, BCardGroup } from 'bootstrap-vue'
import {ProductType} from "@/libs/product";
import {ProductApi} from "@core/api";

export default {
    components: {
        BCardText, BCard, BRow, BCol, BFormGroup, BButton, BCardGroup
    },

    props: {
        displayTypes: {
            type: Array,
            default() {
                return ProductType.all();
            }
        },
        includeTo: {
            default: null
        },
        redirect: {
            default: null
        }
    },

    data() {
        return {
            type: null,
            types: ProductType,
            products: [],
            groups: []
        };
    },

    methods: {
        isTypeSelected(type) {
            return this.type && this.type === type;
        },

        selectProductType(type) {
            this.type = type;
            this.toNextStep();
        },

        toNextStep() {
            const params = {
                includeTo: this.includeTo,
                type: this.type
            };

            if (this.redirect) {
                params['redirect'] = this.redirect;
            }

            this.$router.push({
                name: 'product-new',
                params: params,
                props: {}
            });
        },

        isTypeAvailable(type) {
            return this.displayTypes.includes(type);
        }
    },
    created() {
        ProductApi.getGroups().then(r => this.groups = r.data);
    },
};
</script>
